import { WelcomeBonusJourney } from './WelcomeBonusJourney';

export default WelcomeBonusJourney;
